import React, { useEffect } from "react";
import AgGridTable from "../utilities/AgGridTable";
import { useState } from "react";
import { Grid, TextField } from "@mui/material";
import { useImperativeHandle } from "react";
import { forwardRef } from "react";
import { useRef } from "react";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import moment from "moment";

const StatementOfNOLTE = forwardRef((props, ref) => {
    const invoiceUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.reconciliation}`
    const [rowData, setRowData] = useState([])
    const [totalAmount, setTotalAmount] = useState()
    const gridRef = useRef()
    const [fromDate, setFromDate] = useState(props.fromDate)
    const [toDate, setToDate] = useState(props.toDate)
    const [error, setError] = useState()
    const [successMsg, setSuccessMsg] = useState();
    const [formOpen, setFormOpen] = useState(false);
    
  const showFixedValue = (props) => {
    const options = {
      style: "decimal", // Other options: 'currency', 'percent', etc.
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };
    return (
      <span>
        <p>
          {props?.value
            ? Number(props?.value).toLocaleString("en-US", options)
            : 0.0}
        </p>
      </span>
    );
  };

  const handleDateFormat = (props) => {
    return props?.value && moment(props?.value).format('DD-MM-YYYY')
  }

    const [NKinvoiceNoColumnDefs, setNKInvoiceNoColumnDefs] = useState([
        { field: "invoiceNo", headerName: "NKinvoice_no" },
        { field: "dateOfInvoice", headerName: "Date of Invoice", cellRenderer: handleDateFormat },
        { field: "invoiceAmount", headerName: "Invoice Amount",cellRenderer: showFixedValue },
        { field: "abNumber", headerName: "AB Number" },
        { field: "dueDate", headerName: "Due Date", cellRenderer:handleDateFormat },
        { field: "description", headerName: "description" },
    ])

    const loadStatement = async () => {
        const fromDate = props.fromDate && moment(props?.fromDate).format('YYYY-MM-DD')
        const toDate = props.toDate && moment(props?.toDate).format('YYYY-MM-DD')
        const list = await OAuthService.getList(invoiceUrl + '/invoiceReconcilation?dateFrom=' + fromDate + '&dateTo=' + toDate);
        setRowData(list?.data)
    }

    useEffect(() => {
        if (props.fromDate && props.toDate) {
            loadStatement()
        }
    }, [props])
   

    const importExcel = async () => {
        try {
            const formData = new FormData();
            formData.append("file", props.documentFile);       
            const uploadData = await OAuthService.uploadFile(invoiceUrl + '/uploadInvoiceReconciliationFile', formData);
            setSuccessMsg('Successfully uploaded invoice reconciliation file..')
            setFormOpen(false)
            // props.handleFormClose()
        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
            setSuccessMsg('');
        }
    }
    // console.log(totalAmount);

    useEffect(() => {
        props.successMsg(successMsg)
    }, [successMsg]);

    useImperativeHandle(ref, () => ({
        importExcel: importExcel
    }))
    
    const totalInvoiceAmount = rowData && rowData.reduce((total, invoice) => total + invoice.invoiceAmount, 0);

    const options = {
        style: "decimal", // Other options: 'currency', 'percent', etc.
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      };

    return (
        <>
            <AgGridTable
                rowData={rowData}
                columnDefs={NKinvoiceNoColumnDefs}
                gridRef={gridRef}
            />
            <Grid container spacing={2} className="mt-3">
                <Grid item xs={3.5}>
                    <TextField
                        className="w-[100%]"
                        name='EUR'
                        value="Total"
                        size="small"
                        InputProps={{
                            readOnly: true
                        }}
                    />
                </Grid>
                <Grid item xs={2}>
                    <TextField
                        className="w-[100%]"
                        name='amount'
                        value={rowData && totalInvoiceAmount ?  Number(totalInvoiceAmount).toLocaleString("en-US", options) :0}
                        size="small"
                        InputProps={{
                            readOnly: true
                        }}
                    />
                </Grid>
            </Grid>
        </>
    )
})
export default StatementOfNOLTE